import React from 'react';
import { useFeatureFlag } from 'src/shared/design-system/FeatureFlag';
import { ReferralBannerV2 } from '../ReferralBannerV2';
import { WSSReferralBanner } from './WSSReferralBanner';

export const WSSReferralBannerWrapper: React.FC = () => {
  const exploreWeeklyShefServiceTabsEnabled = useFeatureFlag('exploreWeeklyShefServiceTabsEnabled');
  return exploreWeeklyShefServiceTabsEnabled ? <WSSReferralBanner /> : <ReferralBannerV2 />;
};
